/**
 * liveblog App
 */
import { liveblogContainerWidget } from '@sky-it-cmscomposer/liveblog-widgets';

import DynamicLiveblogContainer from './components/liveblog-container/dynamic-liveblog-container';
import { defineWebComponents } from './utils/web-components-utils';

const webComponentsMap = new Map();
webComponentsMap.set(liveblogContainerWidget.tag, DynamicLiveblogContainer);
console.log('defineWebComponents', { webComponentsMap });

defineWebComponents(webComponentsMap);
